// Copyright (c) 2016 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const SearchByDropdown = t.struct({
    searchBy: t.list(KeyValuePair, 'SearchBy'),
    selectedOption: KeyValuePair
}, {
    name: 'SearchByDropdown',
    strict: true
});

export const getDefaultState = () => new SearchByDropdown({
    searchBy: [],
    selectedOption: {
        key: '',
        value: ''
    }
});

export default SearchByDropdown;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/search-by-dropdown.js